import {
  GET_ADDRESS_LIST,
  GET_ADDRESS_LIST_SUCCESS,
  GET_ADDRESS_LIST_ERROR
} from "../actions";

const INIT_STATE = {
  contactId: null,
  addressList: null,
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADDRESS_LIST:
      return { ...state, loading: true, error: "", contactId: action.payload.contactId };
    case GET_ADDRESS_LIST_SUCCESS:
      return { ...state, loading: false, error: "", addressList: action.payload };
    case GET_ADDRESS_LIST_ERROR:    
        return { ...state, loading: false, error: action.payload.message };      
    default:
      return { ...state };
  }
};
